<script>
import AdminLayout from '@layouts/admin-main'
import { fetchConfig, updateConfig } from '@apis/admin/config'
import { mapState } from 'vuex'
import fromPairs from 'lodash/fromPairs'

export default {
  components: { AdminLayout },
  data() {
    return {
      config: null,
      loading: false,
    }
  },
  computed: {
    ...mapState('common', {
      constants: (state) => state.constants,
    }),
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      Promise.all([this.loadConfig()]).catch((e) =>
        this.$toasted.error(e.message)
      )
    },
    async loadConfig() {
      const { config } = await fetchConfig('mail')
      this.config = config
    },
    handleUpdate() {
      this.loading = true
      this.$confirm(this.$t('admin.msg_save'), this.$t('admin.modal_confirm'), {
        type: 'warning',
      })
        .then(() => updateConfig('mail', this.config))
        .then(() => this.loadConfig())
        .then(() =>
          this.$notify({
            title: this.$t('toasted_msg.title'),
            message: this.$t('admin.msg_save_success'),
            type: 'success',
          })
        )
        .catch((e) => (e === 'cancel' ? null : this.$toasted.error(e.message)))
        .finally(() => {
          this.loading = false
        })
    },
    fromPairs,
  },
  page: {
    title: 'Admin::ConfigMail',
    meta: [{ name: 'description', content: 'Admin::ConfigMail' }],
  },
}
</script>

<style lang="scss" module>
@import '@src/design/default.scss';
@import '@src/design/admin.scss';
@import '@src/design/font.scss';
@import '@src/design/button.scss';
</style>

<template>
  <AdminLayout>
    <div>
      <form
        v-if="config"
        v-loading="loading"
        action="./"
        method="get"
        @submit.prevent="handleUpdate"
      >
        <h3 :class="$style.xeAdmin">{{ $t('admin.mail_setting') }}</h3>
        <div :class="$style.infoText">
          <p>{{ $t('admin.msg_mail_setting') }}</p>
        </div>
        <table :class="$style.rowTable" cellpadding="0">
          <colgroup>
            <col width="200" />
            <col width="35%" />
            <col width="200" />
            <col width="*" />
          </colgroup>
          <tbody>
            <tr>
              <th scope="col"
                ><div>{{ $t('admin.default_sender') }}</div></th
              >
              <td colspan="3">
                <input
                  v-model="config.default_sender"
                  type="text"
                  :class="[$style.inputTypeText, $style.w200]"
                />
              </td>
            </tr>
          </tbody>
        </table>

        <h3 :class="$style.xeAdmin">{{ $t('admin.mail_service') }}</h3>
        <div :class="$style.infoText">
          <p>{{ $t('admin.msg_mail_service') }}</p>
        </div>
        <table :class="$style.rowTable" cellpadding="0">
          <colgroup>
            <col width="200" />
            <col width="35%" />
            <col width="200" />
            <col width="*" />
          </colgroup>
          <tbody>
            <tr>
              <th scope="col"
                ><div>{{ $t('admin.provider') }}</div></th
              >
              <td colspan="3">
                <select v-model="config.provider">
                  <option :value="null">{{ $t('admin.no_send_mail') }}</option>
                  <option
                    v-for="val in constants.mail.provider"
                    :key="val[0]"
                    :value="val[0]"
                    >{{ val[1] }}</option
                  >
                </select>
              </td>
            </tr>
            <template v-if="config.provider === 'MAILGUN'">
              <tr>
                <th scope="col"
                  ><div>{{ $t('admin.provider_domain') }}</div></th
                >
                <td>
                  <input
                    v-model="config.provider_vars[config.provider].domain"
                    type="text"
                    :class="[$style.inputTypeText, $style.fullWidth]"
                  />
                </td>
                <th scope="col"
                  ><div>{{ $t('admin.provider_api_key') }}</div></th
                >
                <td>
                  <input
                    v-model="config.provider_vars[config.provider].api_key"
                    type="password"
                    :class="[$style.inputTypeText, $style.fullWidth]"
                  />
                </td>
              </tr>
            </template>
            <template v-if="config.provider === 'AWS_SES'">
              <tr>
                <th scope="col"
                  ><div>{{ '액세스키 ID' }}</div></th
                >
                <td>
                  <input
                    v-model="
                      config.provider_vars[config.provider].access_key_id
                    "
                    type="text"
                    :class="[$style.inputTypeText, $style.fullWidth]"
                  />
                </td>
                <th scope="col"
                  ><div>{{ '액세스 비밀 키' }}</div></th
                >
                <td>
                  <input
                    v-model="
                      config.provider_vars[config.provider].secret_access_key
                    "
                    type="password"
                    :class="[$style.inputTypeText, $style.fullWidth]"
                  />
                </td>
              </tr>
              <tr>
                <th scope="col"
                  ><div>{{ '지역' }}</div></th
                >
                <td colspan="3">
                  <input
                    v-model="config.provider_vars[config.provider].region"
                    type="text"
                    :class="[$style.inputTypeText, $style.fullWidth]"
                  />
                </td>
              </tr>
            </template>
            <template v-if="config.provider === 'FAKE'">
              <tr>
                <td :colspan="4">
                  {{ $t('admin.msg_fake') }}
                </td>
              </tr>
            </template>
          </tbody>
        </table>
        <div :class="$style.buttonArea">
          <span :class="[$style.button, $style.black, $style.large]"
            ><input type="submit" accesskey="s" :value="$t('admin.save')"
          /></span>
        </div>
      </form>
    </div>
  </AdminLayout>
</template>
